import { render, staticRenderFns } from "./passed-dialog.vue?vue&type=template&id=738ab84b&scoped=true&"
import script from "./passed-dialog.vue?vue&type=script&lang=js&"
export * from "./passed-dialog.vue?vue&type=script&lang=js&"
import style0 from "./passed-dialog.vue?vue&type=style&index=0&id=738ab84b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738ab84b",
  null
  
)

export default component.exports